import React from 'react'
import Loader from 'components/Loader'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Locations from 'containers/Locations/Locations'
import MonthlyEvaluationReportHeader from './MonthlyEvaluationReportHeader'
import MonthlyEvaluationReportChart from './MonthlyEvaluationReportChart'

const MonthlyEvaluationReport = ({ isLoaded }) => {
  if (!isLoaded) {
    return <Loader full />
  }

  return (
    <React.Fragment>
      <MonthlyEvaluationReportHeader />
      <Locations />
      <MonthlyEvaluationReportChart />
    </React.Fragment>
  )
}

MonthlyEvaluationReport.propTypes = {
  isLoaded: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    isLoaded: state.init.isFinished
  }
}

export default connect(mapStateToProps)(MonthlyEvaluationReport)
